module.exports = __webpack_public_path__ + "media/generic_scholarship_search/scholarship_widget_state_1-25bc8adc.png";